export const ACCESS_TOKEN = "accessToken";

export const removeMagicTokenFromSearchParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const currentUrl = new URL(window.location.href);
  urlParams.delete("magicToken");
  currentUrl.search = urlParams.toString();

  window.history.replaceState({}, "", currentUrl.toString());
};

export const getMagicTokenFromSearchParams = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("magicToken");
};
